// Centralized API Configuration Constants
// This file contains all API-related constants that can be shared across the application

// Environment detection
const detectEnvironment = (): 'development' | 'staging' | 'production' => {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return 'development';
  if (hostname.startsWith('dev.')) return 'staging';
  return 'production';
};

const ENV = detectEnvironment();

export const API_CONFIG = {
  // API Gateway URL - Environment-specific
  BASE_URL: ENV === 'staging' 
    ? 'https://j4pza5h9ql.execute-api.us-east-1.amazonaws.com/Stage'  // Development environment
    : 'https://j4pza5h9ql.execute-api.us-east-1.amazonaws.com/Prod', // Production environment
  
  // Environment-specific configurations
  ENVIRONMENT: ENV,
  
  // Development proxy (for local development)
  DEV_PROXY: ENV === 'staging'
    ? 'https://j4pza5h9ql.execute-api.us-east-1.amazonaws.com/Stage'  // Development environment
    : 'https://j4pza5h9ql.execute-api.us-east-1.amazonaws.com/Prod', // Production environment
  
  // Environment-specific features
  FEATURES: {
    DEBUG_MODE: ENV === 'development' || ENV === 'staging',
    LOGGING: ENV === 'development' || ENV === 'staging',
    ANALYTICS: ENV === 'production'
  }
} as const;

// Helper functions
export const getApiBaseUrl = (): string => API_CONFIG.BASE_URL;
export const getEnvironment = (): string => API_CONFIG.ENVIRONMENT;
export const isDevelopment = (): boolean => ENV === 'development';
export const isStaging = (): boolean => ENV === 'staging';
export const isProduction = (): boolean => ENV === 'production'; 